import { IconSwapArrows } from "./MatchControlIcons";
import { teamRawPlayerNames } from "../../../registry/utils/courtTeams";
import {
  courtServeAnchorClass,
  courtServeTextAnchor,
  pctPos,
} from "../utils/courtGeometry";

export default function CourtReadyOverlay({
  portrait,
  endsSwapped,
  teamA,
  teamB,
  serving,
  vbW,
  vbH,
  onSwapCourt,
  onSwapPartners,
  onPickServe,
}) {
  const pos = (x, y) => pctPos(x, y, vbW, vbH);
  const topSide = endsSwapped ? "B" : "A";
  const bottomSide = endsSwapped ? "A" : "B";
  const leftSide = endsSwapped ? "B" : "A";
  const rightSide = endsSwapped ? "A" : "B";
  const teamFor = (side) => (side === "A" ? teamA : teamB);
  const swapBtn = (key, style, cls, aria, onClick, vert) => (
    <button
      key={key}
      type="button"
      className={`court-arr-btn ${cls}${vert ? " vert" : ""}`}
      style={style}
      aria-label={aria}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <IconSwapArrows stroke="currentColor" size={20} />
    </button>
  );
  const serveBtn = (half, side) => {
    const team = teamFor(side);
    const p = courtServeTextAnchor(portrait, half, vbW, vbH, team);
    const isA = side === "A";
    const active = serving === side;
    const teamName = (team?.name || `Side ${side}`).trim();
    const shortName =
      teamName.length > 14 ? `${teamName.slice(0, 12)}…` : teamName;
    return (
      <button
        key={`serve-${side}`}
        type="button"
        className={`court-serve-btn pick ${courtServeAnchorClass(portrait)}${active ? " on" : ""}${isA ? " side-a" : " side-b"}`}
        style={pos(p.x, p.y)}
        aria-label={
          active
            ? `${shortName} serves first`
            : `Set ${shortName} as serving side`
        }
        title={active ? "This side serves first" : "Tap to choose serving side"}
        onClick={(e) => {
          e.stopPropagation();
          onPickServe(side);
        }}
      >
        {active ? <>🏸 Serving</> : <>Serve side</>}
      </button>
    );
  };
  const halves = portrait
    ? [
        { half: "top", side: topSide, y: 90 },
        { half: "bottom", side: bottomSide, y: 349 },
      ]
    : [
        { half: "left", side: leftSide, x: 82, y: 100 },
        { half: "right", side: rightSide, x: 358, y: 100 },
      ];
  return (
    <>
      {swapBtn(
        "net",
        pos(portrait ? 100 : 219.5, portrait ? 219.5 : 100),
        "net",
        "Swap court sides",
        onSwapCourt,
        portrait
      )}
      {halves.map(({ half, side, y, x }) => {
        const players = teamRawPlayerNames(teamFor(side));
        const swap =
          players.length >= 2
            ? swapBtn(
                `partners-${half}`,
                portrait ? pos(100, y) : pos(x, y),
                side === "A" ? "side-a" : "side-b",
                `Swap doubles partners side ${side}`,
                () => onSwapPartners(side),
                !portrait
              )
            : null;
        return (
          <span key={half}>
            {swap}
            {serveBtn(half, side)}
          </span>
        );
      })}
    </>
  );
}
